import moment from "moment";


function ProofOfPlayMultiResourceCtrl(
  $scope,
  $state,
  $stateParams,
  sweet,
  DateManipulationService,
  ProofOfPlayReportsV2Service,
  ProofPlayService,
  ToastsService
) {
  "ngInject";

  let vm = this;

  vm.radioButtonChoices = {
    group1: 'By Device',
    group2: 'By Date',
    selection: null
  };

  vm.dateTimeSelection = {
    start: null,
    end: null
  };

  vm.formValidity = {
    start_date: false,
    end_date: false,
    resources: false,
  };

  vm.tenant = $stateParams.tenantId;
  vm.loading = true;
  vm.disabled = true;
  vm.disabledTenant = true;
  vm.selected_resources = [];

  vm.initialize = () => {
    ProofPlayService.getAllResources(vm.tenant)
      .then(function (data) {
        vm.loading = false;
        vm.full_resource_map = data.data.resources;
        vm.resources = [];
        for (let i = 0; i < data.data.resources.length; i++) {
          let resource = data.data.resources[i];
          vm.resources.push(resource.resource_name);
        }

        if (vm.resources.length > 0) {
          return vm.had_some_items = true;
        } else {
          return vm.had_some_items = false;
        }
      })
  };

  vm.refreshResources = function () {
    vm.searchText = '';
    vm.selectedItem = '';
    vm.loading = true;
    vm.disabled = true;
    vm.selected_resources = [];
    vm.initialize();
  };

  vm.addToSelectedResources = function (searchText) {
    if (vm.isResourceValid(searchText)) {
      vm.selected_resources.push(searchText);
      let index = vm.resources.indexOf(searchText);
      vm.resources.splice(index, 1);
      vm.searchText = '';
    }
    vm.areResourcesValid();
    return vm.isDisabled();
  };

  vm.querySearch = (resources, searchText) => {
    ProofPlayService.querySearch(resources, searchText);
  }

  vm.isRadioValid = function (selection) {
    vm.formValidity.type = selection;
    return vm.isDisabled();
  };

  vm.isResourceValid = function (searchText) {
    if (__in__(searchText, vm.resources)) {
      if (!__in__(searchText, vm.selected_resources)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };


  vm.areResourcesValid = function () {
    vm.formValidity.resources = (vm.selected_resources.length > 0);
    return vm.isDisabled();
  };

  vm.isStartDateValid = function (start_date) {
    vm.formValidity.start_date = (start_date instanceof Date);
    return vm.isDisabled();
  };


  vm.isEndDateValid = function (end_date) {
    vm.formValidity.end_date = (end_date instanceof Date);
    return vm.isDisabled();
  };

  vm.removeFromSelectedResource = function (item) {
    let index = vm.selected_resources.indexOf(item);
    vm.selected_resources.splice(index, 1);
    vm.resources.push(item);
    vm.areResourcesValid();
    return vm.isDisabled();
  };

  vm.isDisabled = function () {
    if (vm.formValidity.start_date && vm.formValidity.end_date && vm.formValidity.resources && vm.formValidity.type) {
      vm.disabled = false;
      vm.final = {
        start_date: DateManipulationService.isoDate(vm.dateTimeSelection.start),
        end_date: DateManipulationService.isoDate(vm.dateTimeSelection.end),
        resources: vm.selected_resources,
        type: vm.radioButtonChoices.selection
      }
    } else {
      return vm.disabled = true;
    }
  };

  vm.submit = function () {
    let resources_as_ids = [];
    for (let i = 0; i < vm.final.resources.length; i++) {
      let item = vm.final.resources[i];
      for (let j = 0; j < vm.full_resource_map.length; j++) {
        let each = vm.full_resource_map[j];
        if (each["resource_name"] === item) {
          resources_as_ids.push(each["resource_identifier"]);
        }
      }
    }

    let reportType = {
      '1': 'MULTI_RESOURCE_BY_DEVICE',
      '2': 'MULTI_RESOURCE_BY_DATE',
    }[vm.final.type];
    let data = {
      'tenantId': vm.tenant,  // this is actually tenantId
      'type': reportType,
      'startDate': vm.final.start_date,
      'endDate': vm.final.end_date,
      'parameters': {
        'resourceIdentifiers': resources_as_ids,
      }
    };
    return ProofOfPlayReportsV2Service.post(data)
      .then(() => {
        return $scope.changeToReportList();
        //return $state.go('tenantProofPlay',
          //{tenantId: $stateParams.tenantId});  // explicitly passing because the routes aren't siblings (they aren't acually nested)
      }, () => {
        return sweet.show('Oops...', 'There was a problem queueing the report.', 'error');
      });
  };

  vm.currentTenant = vm.tenant;

  vm.querySearch = (resources, searchText) => ProofPlayService.querySearch(resources, searchText);


  return vm;
};

function __in__(needle, haystack) {
  return haystack.indexOf(needle) >= 0;
}

export {ProofOfPlayMultiResourceCtrl}
